import { Assets, BitmapFont, bitmapFontXMLStringParser, Texture } from 'pixi.js';

/*
  This is a copy of the install function from pixi.js: https://github.com/pixijs/pixijs/blob/v5.3.x/packages/text-bitmap/src/BitmapFont.ts#L269
  it would call XMLStringFormat.parse(data), which would truncate decimal for xoffset, yoffset, xadvance, and size
  so the BitmapFont would be created using only integer values, leading to offset when rendering text
  this updated version allows us to keep the decimal values when we create the BitmapFont
*/
export default function installBitmapFont(data: string, texturesProp: Texture | Texture[]): BitmapFont {
  let textures = texturesProp;
  const fontData = bitmapFontXMLStringParser.parse(data);
  if (textures instanceof Texture) {
    textures = [textures];
  }

  const font = new BitmapFont({
    data: fontData,
    textures
  });

  Assets.cache.set(`${fontData.fontFamily}`, font);

  return font;
}
